module.exports = __webpack_public_path__ + "static/media/APP-min.cbd6742b.webp";